import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { confirmPopup } from "primereact/confirmpopup";
import { deleteEnquiry, getEnquiries } from "../../redux/actions/enquiriesAction";

export default function Index() {
    const history = useHistory();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getEnquiries());
    }, [dispatch]);

    let { enquiries } = useSelector((state) => state.enquiry);

    const [search, setSearch] = useState("");

    const getFilteredData = (data, search) => {
        if (search.length) {
            data = data.filter(
                (item) =>
                    item?.fullName?.toLowerCase()?.includes(search.toLowerCase())
                    || item?.email?.toLowerCase()?.includes(search.toLowerCase())
                    || item?.subject?.toLowerCase()?.includes(search.toLowerCase())
                    || item?.message?.toLowerCase()?.includes(search.toLowerCase())

            );
        }
        return data;
    };

    enquiries = getFilteredData(enquiries, search);

    const onDelete = (e, id) => {
        confirmPopup({
            target: e.currentTarget,
            message: "Are you sure you want to delete this enquiry? This action will permanently delete the user account. This action cannot be undone.",
            icon: "pi pi-exclamation-triangle",
            accept: () => dispatch(deleteEnquiry(id)),
            reject: () => { },
        });
    };

    return {
        enquiries,
        history,
        search,
        setSearch,
        dispatch,
        onDelete
    };
}
